import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Button from './ui/Button';
import { useGlobalContext } from "./../component/GlobalContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@radix-ui/react-dropdown-menu";
import {
  LayoutDashboard,
  User,
  Heart,
  FolderTree,
  CreditCard,
  LogOut,
  ChevronDown,
  Ticket, User2, Users,
  PartyPopper,
  BookImage,
  Menu
} from "lucide-react";

import { Avatar, AvatarFallback } from "@radix-ui/react-avatar";
import Tippy from "@tippyjs/react";

const Header = () => {

  const { globalUserVar, isAuthenticated, setIsAuthenticated, isActiveMember } = useGlobalContext();
  const [firstName, setFirstName] = useState("");
  const [role, setRole] = useState("");
  const [planType, setPlanType] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const [planAmount, setPlanAmount] = useState("");

  const navigate = useNavigate();
  const transparent = false;
  // Check and assign the value
  useEffect(() => {
    // console.log('here');
    if (isAuthenticated) {
      let userObj = localStorage.getItem('userObj');
      if (userObj != null && userObj !== "") {
        let userJson = JSON.parse(userObj);
        setFirstName(userJson.first_name)
        setRole(userJson.role.name)
        setPlanType(userJson.plan_type)
        setPlanAmount(userJson.plan_amount)
      }
    }
    // alert(isAuthenticated)
  }, [isAuthenticated,isActiveMember]);

  const logOutHandler = () => {
    localStorage.clear();
    setIsAuthenticated(false);
    navigate('/');
    // window.location.reload()
  }

  // const role = 'admin';
  return (
    <nav className={`border-b bg-white z-50 relative`}>      
      <div className="flex justify-between items-center px-4 py-3 md:px-6">
        <Link to="/" className="flex items-center">
          <img src="/logo-CwJXNP93.svg" alt="Logo" className="h-12 w-[82px]" />
        </Link>
        <button onClick={() => setMenuOpen(!menuOpen)} className="md:hidden focus:outline-none">
          <Menu className="h-6 w-6" />
        </button>
        <div className="hidden md:flex items-center gap-6">
          {(isAuthenticated && isActiveMember) && (
            <Link to="/" className="text-sm font-semibold hover:text-primary">
              (Active Plan - {planType === "month" ? `Monthly : $${planAmount}` : `Annual : $${planAmount}`})
            </Link>
          )}
          <Link to="/" className="text-sm font-semibold hover:text-primary">Home</Link>
          <Link to="/event-calender" className="text-sm font-semibold hover:text-primary">Events Calendar</Link>
          <DropdownMenu>
            <DropdownMenuTrigger className="flex items-center text-sm font-semibold hover:text-primary">Membership <ChevronDown className="ml-1 h-4 w-4" /></DropdownMenuTrigger>
            <DropdownMenuContent className="bg-white border rounded-md shadow-md py-2 w-56">
              <DropdownMenuItem className="header-dropdown-menu-item"><Link to="/subscription/member">Join the Family Fun Club</Link></DropdownMenuItem>
              {!isAuthenticated && (
                <DropdownMenuItem className="header-dropdown-menu-item"><Link to="/login">Member Sign In</Link></DropdownMenuItem>
              )}
            </DropdownMenuContent>
          </DropdownMenu>
          <DropdownMenu>
            <DropdownMenuTrigger className="flex items-center text-sm font-semibold hover:text-primary">Business Partners <ChevronDown className="ml-1 h-4 w-4" /></DropdownMenuTrigger>
            <DropdownMenuContent className="bg-white border rounded-md shadow-md py-2 w-56">
              <DropdownMenuItem className="header-dropdown-menu-item"><Link to="/subscription/vendor">Become a Preferred Business Partner</Link></DropdownMenuItem>
              {!isAuthenticated && (
                <DropdownMenuItem className="header-dropdown-menu-item"><Link to="/vendor/login">Business Sign In</Link></DropdownMenuItem>
              )}
            </DropdownMenuContent>
          </DropdownMenu>
          <Link to="/contact-us" className="text-sm font-semibold hover:text-primary">Contact Us</Link>
          <a href="https://www.facebook.com/familyfunaz/events" target="_blank" className="text-sm font-semibold hover:text-primary">Get Social</a>
          <div className="flex items-center gap-2 ml-4">
            {isAuthenticated ? (
              <DropdownMenu>
                <DropdownMenuTrigger className="flex items-center gap-2 cursor-pointer">
                  <Tippy content={`${role === "vendor" ? "User" : firstName}`}>
                    <span className="username text-sm font-medium">{role === "vendor" ? "User" : firstName}</span>
                  </Tippy>
                  <ChevronDown className="h-4 w-4" />
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="bg-white border rounded-md shadow-md py-2 w-56">
                  <DropdownMenuItem><Link to="/dashboard" className="flex items-center w-full"><LayoutDashboard className="mr-2 h-4 w-4" />Dashboard</Link></DropdownMenuItem>
                  <DropdownMenuItem><Link to="/account-details" className="flex items-center w-full"><User className="mr-2 h-4 w-4" />Account Details</Link></DropdownMenuItem>
                  <DropdownMenuItem><Link to="/coupons" className="flex items-center w-full"><Ticket className="mr-2 h-4 w-4" />Deals</Link></DropdownMenuItem>
                  {role === "Admin" && (
                    <>
                      <DropdownMenuItem><Link to="/vendors" className="flex items-center w-full"><Users className="mr-2 h-4 w-4" />Vendors</Link></DropdownMenuItem>
                      <DropdownMenuItem><Link to="/members" className="flex items-center w-full"><User2 className="mr-2 h-4 w-4" />Members</Link></DropdownMenuItem>
                      <DropdownMenuItem><Link to="/categories" className="flex items-center w-full"><FolderTree className="mr-2 h-4 w-4" />Categories</Link></DropdownMenuItem>
                      <DropdownMenuItem><Link to="/media-gallery" className="flex items-center w-full"><BookImage className="mr-2 h-4 w-4" />Gallery</Link></DropdownMenuItem>
                      <DropdownMenuItem><Link to="/events" className="flex items-center w-full"><PartyPopper className="mr-2 h-4 w-4" />Events</Link></DropdownMenuItem>
                    </>
                  )}
                  <DropdownMenuItem onClick={logOutHandler}><Link to="/manage/members" className="flex items-center w-full"><LogOut className="mr-2 h-4 w-4" />Log out</Link></DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            ) : (
              <DropdownMenu>
                <DropdownMenuTrigger className="flex items-center text-sm font-semibold hover:text-primary">Sign in <ChevronDown className="ml-1 h-4 w-4" /></DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="bg-white border rounded-md shadow-md py-2 w-56">
                  <DropdownMenuItem><Link to="/login" className="block w-full">Members</Link></DropdownMenuItem>
                  <DropdownMenuItem><Link to="/vendor/login" className="block w-full">Partners</Link></DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            )}
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden flex flex-col gap-4 px-4 pb-4">
          {(isAuthenticated && isActiveMember) && (
            <Link to="/">(Active Plan - {planType === "month" ? `Monthly : $${planAmount}` : `Annual : $${planAmount}`})</Link>
          )}
          <Link to="/">Home</Link>
          <Link to="/event-calender">Events Calendar</Link>
          <Link to="/subscription/member">Join the Family Fun Club</Link>
          {!isAuthenticated && <Link to="/login">Member Sign In</Link>}
          <Link to="/subscription/vendor">Become a Preferred Business Partner</Link>
          {!isAuthenticated && <Link to="/vendor/login">Business Sign In</Link>}
          <Link to="/contact-us">Contact Us</Link>
          <a href="https://www.facebook.com/familyfunaz/events" target="_blank">Get Social</a>
          {isAuthenticated && (
            <>
              <Link to="/dashboard">Dashboard</Link>
              <Link to="/account-details">Account Details</Link>
              <Link to="/coupons">Deals</Link>
              {role === "Admin" && (
                <>
                  <Link to="/vendors">Vendors</Link>
                  <Link to="/members">Members</Link>
                  <Link to="/categories">Categories</Link>
                  <Link to="/media-gallery">Gallery</Link>
                  <Link to="/events">Events</Link>
                </>
              )}
              <button onClick={logOutHandler}>Log out</button>
            </>
          )}
        </div>
      )}
    </nav>
  )
}

export default Header